export default __webpack_public_path__ + "static/media/fm_fit_size.c33fff6b.png";